<template>
  <div class="mic-com cube">
    <div class="entry-list" :style="style" v-if="displayList.length">
      <Entry v-for="item in cellList"
             :key="item.key"
             :style="item.style"
             :data="item"
      />
    </div>
    <div class="empty" v-else>
      <img alt="" src="https://files.1card1.cn/VipCloudSite/10/20200401/036d1f9ff980465f8e067f6f3f93def8.png"/>
    </div>
  </div>
</template>

<script>
  import Entry from './Entry';
  import Common from '../mixins/Common';

  export default {
	name: 'Cube',
	props: {},
	mixins: [Common],
	components: {Entry},
	data() {
	  return {
		clientWidth: 375,
	  };
	},
	mounted() {
	  this.$nextTick(() => {
		this.clientWidth = this.$el.clientWidth;
	  });
	},
	methods: {},
	computed: {
	  displayList() {
		return this.config.sub_entry.reduce((pre, it) => it.image_url ? [...pre, it] : pre, []);
	  },

	  style() {
		return {
		  height: this.height + 'px',
		  width: this.width + 'px',
		  margin: -this.config.border_width / 2 + 'px'
		};
	  },
	  width() {
		return this.clientWidth + this.config.border_width - this.config.page_margin * 2;
	  },
	  height() {
		// 计算每个格子的top+height,取最大值
		return this.cellList.reduce((p, it) => Math.max((parseFloat(it.style.top) + parseFloat(it.style.height)), p), 0);
	  },
	  size() {
		return this.width / this.config.layout_width;
	  },
	  cellList() {
		return this.displayList.map(it => ({
		  ...it,
		  style: {
			left: this.cellWidth * it.x + 'px',
			top: this.cellHeight * it.y + 'px',
			width: this.cellWidth * it.width + 'px',
			height: this.cellHeight * it.height + 'px',
			border: this.config.border_width / 2 + 'px solid transparent'
		  }
		}));
	  },

	  first() {
		if (!this.displayList.length) return null;
		return this.displayList[0];
	  },
	  cellHeight() {
		if (!this.first) return 0;
		if (![0, 1, 2].includes(this.config.show_method)) return this.size;
		const ratio = this.first.image_height / this.first.image_width;
		return ratio * this.cellWidth;
	  },
	  cellWidth() {
		if (!this.first) return 0;
		if (![0, 1, 2].includes(this.config.show_method)) return this.size;
		return [this.width / 2, this.width / 3, this.width / 4][this.config.show_method] / this.first.width;
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .cube {
    overflow: hidden;
    display: flex;
    justify-content: center;

    .entry-list {
      position: relative;
    }

    .empty {
      img {
        height: 250px;
        object-fit: cover;
        width: 100%;
      }
    }
  }
</style>
